export function repositoryMutation(database, operation) {
    return {
        commit: async () => database.transaction("IMMEDIATE", (transaction) => {
            const result = operation(transaction);
            if (result === undefined)
                return { eventSequences: [], events: [] };
            const sequence = appendRepositoryEvent(transaction, result.entityId, result.event);
            return { eventSequences: [sequence], events: [result.event] };
        }),
    };
}
export function appendRepositoryEvent(transaction, entityId, event) {
    transaction.exec(`INSERT INTO repository_events(event_type, entity_id, occurred_at, payload_json)
      VALUES (?, ?, ?, ?)`, { bind: [event.type, entityId, event.occurredAt, JSON.stringify(event.payload)] });
    return Number(transaction.selectValue("SELECT last_insert_rowid()"));
}
export function canonicalJson(value) {
    if (Array.isArray(value))
        return `[${value.map(canonicalJson).join(",")}]`;
    if (value !== null && typeof value === "object") {
        return `{${Object.keys(value).sort().map((key) => (`${JSON.stringify(key)}:${canonicalJson(value[key])}`)).join(",")}}`;
    }
    return JSON.stringify(value);
}
export function requiredString(value, field) {
    if (typeof value !== "string")
        throw new TypeError(`Expected ${field} to be a string`);
    return value;
}
//# sourceMappingURL=transaction.js.map